import React, { useEffect, useState } from 'react';

/**
 * AsicsGorunurluk: High5'in ASICS arama kampanyası için görünürlük, ses payı ve
 * bütçe senaryosu sunumu.
 * Route: /r/asics-gorunurluk (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 20 slayt, 16:9. Tasarım dili Club Sporium teklifinden geliyor, CSS'i onunla
 * ve iki Gürgençler sunumuyla ortak; üçü de canlıda duruyor ve bozulmamalı.
 * Yeniden üretmek için: node src/pages/asics-gorunurluk/build.js
 *
 * 🔑 "PDF indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P slaytları
 * tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~100KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function AsicsGorunurluk() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./asicsGorunurlukHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="ASICS · Arama Görünürlüğü ve Ses Payı"
      srcDoc={html}
      style={fill}
    />
  );
}
